import React from 'react';
import { Bot, RotateCcw, Menu, X, Sparkles } from 'lucide-react';

interface ChatHeaderProps {
  onMenuClick?: () => void;
  onClearClick?: () => void;
  hasMessages?: boolean;
  isMobile?: boolean;
}

/**
 * ChatHeader - Fixed header for chat interface
 */
export const ChatHeader: React.FC<ChatHeaderProps> = ({
  onMenuClick,
  onClearClick,
  hasMessages = false,
  isMobile = false,
}) => {
  // Debug
  React.useEffect(() => {
    console.log('✅ ChatHeader rendered with title visible');
  }, []);

  return (
    <div 
      className="h-16 px-4 sm:px-6 flex items-center justify-between flex-shrink-0 bg-[rgb(var(--bg))]"
      style={{
        display: 'flex',
        visibility: 'visible',
        opacity: 1,
        minHeight: '64px',
      }}
    >
      <div className="flex items-center space-x-3">
        {isMobile && (
          <button
            onClick={onMenuClick}
            className="p-2 hover:bg-[rgb(var(--card))] rounded-lg transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Toggle menu"
          >
            <Menu className="w-5 h-5 text-[rgb(var(--fg))]" />
          </button>
        )}
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gradient-to-br from-[#9c68f2] to-[#422ca5] rounded-lg flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
          <div className="flex flex-col">
            <h1 
              className="text-base font-semibold text-[rgb(var(--fg))] leading-tight"
              style={{
                display: 'block',
                visibility: 'visible',
                opacity: 1,
                color: 'rgb(var(--fg))',
              }}
            >
              Fiverflow Assistant
            </h1>
            <p 
              className="text-xs text-[rgb(var(--muted))] leading-tight"
              style={{
                display: 'block',
                visibility: 'visible',
                opacity: 1,
              }}
            >
              Your AI-powered workflow partner
            </p>
          </div>
        </div>
      </div>
      {hasMessages && onClearClick && (
        <button
          onClick={onClearClick}
          className="flex items-center space-x-2 px-3 py-1.5 text-sm text-[rgb(var(--muted))] hover:bg-[rgb(var(--card))] rounded-lg transition-colors min-h-[44px]"
        >
          <RotateCcw className="w-4 h-4" />
          <span className="hidden sm:inline">Clear</span>
        </button>
      )}
    </div>
  );
};

